import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ProfileSection } from "@/components/account/ProfileSection";
import { WalletsSection } from "@/components/account/WalletsSection";
import { SecuritySection } from "@/components/account/SecuritySection";
import { BillingSection } from "@/components/account/BillingSection";
import { AlertsSection } from "@/components/account/AlertsSection";

export default function Account() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState(new URLSearchParams(window.location.search).get("tab") || "profile");

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);
  if (!user) return null;

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12" data-testid="account-page">
      <p className="font-mono-cl text-[11px] tracking-[0.24em] uppercase text-[#ccff00]">Account</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">{user.nickname ? `@${user.nickname}` : user.name}</h1>
      <div className="flex flex-wrap gap-x-6 gap-y-1 mt-3 text-sm text-zinc-400">
        <span>User ID <b data-testid="account-public-id" className="font-mono-cl text-zinc-200">{user.public_id}</b></span>
        {user.nickname && <Link to={`/u/${user.nickname}`} data-testid="account-public-profile-link" className="text-[#ccff00] hover:underline">View public profile</Link>}
      </div>
      <Tabs value={tab} onValueChange={setTab} className="mt-10">
        <TabsList className="bg-white/[0.04] border border-white/10 rounded-full p-1">
          <TabsTrigger data-testid="account-tab-profile" value="profile" className="rounded-full data-[state=active]:bg-[#ccff00] data-[state=active]:text-black">Profile</TabsTrigger>
          <TabsTrigger data-testid="account-tab-billing" value="billing" className="rounded-full data-[state=active]:bg-[#ccff00] data-[state=active]:text-black">Billing</TabsTrigger>
          <TabsTrigger data-testid="account-tab-wallets" value="wallets" className="rounded-full data-[state=active]:bg-[#ccff00] data-[state=active]:text-black">Wallets</TabsTrigger>
          <TabsTrigger data-testid="account-tab-security" value="security" className="rounded-full data-[state=active]:bg-[#ccff00] data-[state=active]:text-black">Security</TabsTrigger>
          <TabsTrigger data-testid="account-tab-alerts" value="alerts" className="rounded-full data-[state=active]:bg-[#ccff00] data-[state=active]:text-black">Alerts</TabsTrigger>
        </TabsList>
        <TabsContent value="profile" className="mt-8"><ProfileSection /></TabsContent>
        <TabsContent value="alerts" className="mt-8"><AlertsSection /></TabsContent>
        <TabsContent value="billing" className="mt-8"><BillingSection /></TabsContent>
        <TabsContent value="wallets" className="mt-8"><WalletsSection /></TabsContent>
        <TabsContent value="security" className="mt-8"><SecuritySection /></TabsContent>
      </Tabs>
    </div>
  );
}
